import React, { useContext } from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';

import DashboardHeroFaq from '#components/dashboard-hero-faq';
import Helper from '#components/helper';
import { eventGtag } from '#app/hooks/eventGtag';
import { H4, Paragraph } from '#styleguide/index';
import { useUserContext } from '#hooks/index';
import { UserDropdown } from '#components/index';
import Navegation from '#layout/navegation';

import GlobalContext from '../../context/Global/GlobalContext';

const Payments = () => {
  const {
 cleanPrevPath, isLoginUser, updateCurrentPosition, cleanPurchaseData 
} =
    useContext(GlobalContext);
  const router = useRouter();
  const { loading, data } = useUserContext({ withVerification: true });
  const userContextData = { loading, data };

  const onClickLogout = () => {
    window.localStorage.removeItem('accessToken');
    window.localStorage.removeItem('refreshToken');
    window.localStorage.removeItem('userData');
    isLoginUser(false);
    updateCurrentPosition('register');
    cleanPurchaseData();
    cleanPrevPath();
    router.push('/login');
    eventGtag('cerrar_sesion_menu', userContextData.data);
  };

  return (
    <>
      <Head>
        <title>Rutas y Cursos | Crack The Code</title>
      </Head>
      <Navegation>
        <div className="navbar">
          {!userContextData?.loading && userContextData?.data && (
            <UserDropdown
              data={userContextData.data}
              onClickLogout={onClickLogout}
              isLetterAvatar={true}
            />
          )}
        </div>
        <main className="pagos_container">
          {/* pagos */}
          <section className="pagos">
            {/* Hero */}
            <DashboardHeroFaq
              title={`Mis pagos`}
              content="Historial de pagos"
              existVirtualRoom
            />

            {/* Container */}
            <section className="pagos__pago-container">
              {/* Container */}
              <div className="container">
                {/* Imagen */}
                <div className="container__img">
                  <img src="/dashboard/painter.png" alt="background" />
                </div>

                {/* Information */}
                <div className="information">
                  <H4>¡Estamos trabajando!</H4>
                  <Paragraph size="28">
                    Próximamente tendrás la posibilidad de ver aquí el historial de los
                    pagos que hayas realizado.
                  </Paragraph>
                </div>
              </div>

              {/* Helper */}
              <Helper
                title="¿Consultas sobre tus pagos?"
                description="Mientras tanto contáctate directamente con nosotros para poder ayudarte"
              />
            </section>
          </section>

          {/* Imagen */}
          <section className="image">
            <img src="/dashboard/pagos.png" alt="faq" />
          </section>

          {/* Background */}
          <img
            className="background"
            src="/dashboard/pagos-background.png"
            alt="background"
          />
        </main>
      </Navegation>
    </>
  );
};

export default Payments;
